<app-header [selectedMenu]="MENU_PAGE.LEGAL_NOTICE"></app-header>

<div class="container">

  <div class="wrapper">

    <aside class="rope"></aside>
    <app-back-btn></app-back-btn>


    <section class="legal-notice">

      <div class="inner wrap">


        <div class="setting-box">


          <article class="book-layout">

            <div class="book-layout-wrap type-page-list-none">

              <div class="book-page-list">

                <div class="book-page-group">

                  <div class="page-box">
                    <div class="page-content scroll-effect over-y">
                      <div class="list-wrap">

                        <div class="title">개인정보처리방침</div>

                        <div class="des-box">
                          ‘듣고 배우는 한국어’라는 명칭으로 앱과 웹으로 제공이 되는 본 온라인 서비스는 개인의 정보를 수집을 하지 않습니다.
                        </div>
                        
                      </div>

                    </div>
                  </div>
                </div>

              </div>

            </div>

          </article>

        </div>

      </div>
    </section>

  </div>

  <!-- app-footer></app-footer -->

</div>
